/**
 * StretchedLink Class
 */
export class StretchedLink {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 */
	constructor( containerEl ) {

		this.containerEl = containerEl;
		this.allBlocks = document.querySelectorAll( containerEl );

		if ( this.allBlocks.length === 0 ) {

			return;

		}

		this.init();

	}

	/**
	 * Init
	 */
	init() {

		this.allBlocks.forEach( ( block ) => {

			const anchor = block.querySelector( 'a' );
			if ( !anchor ) {

				return;

			}

			if ( this.containerEl === '.b-person-box' ) {

				this.setupPersonBox( block, anchor );

			} else if ( this.containerEl === '.b-icon-card' ) {

				this.setupIconCard( block, anchor );

			} else {

				this.setupStretchedLink( anchor );

			}

		} );

	}

	/**
	 * Setup person box functionality
	 * @param {HTMLElement} block
	 * @param {HTMLElement} anchor
	 */
	setupPersonBox( block, anchor ) {

		const href = anchor.getAttribute( 'href' );

		if ( !href ) {

			return;

		}

		const target = anchor.getAttribute( 'target' );

		block.addEventListener( 'click', ( e ) => {

			// Prevent double navigation if clicking directly on anchor
			if ( e.target.tagName === 'A' ) {

				return;

			}

			this.navigateToUrl( href, target );

		} );

		block.classList.add( 'has-stretched-link' );

	}

	/**
	 * Setup stretched link functionality
	 * @param {HTMLElement} anchor
	 */
	setupStretchedLink( anchor ) {

		const href = anchor.getAttribute( 'href' );
		if ( href && href.trim() !== '' ) {

			anchor.classList.add( 'is-stretched-link' );

			const container = anchor.closest( this.containerEl );
			if ( container ) {

				container.classList.add( 'has-stretched-link' );

			}

		}

	}

	/**
	 * Setup icon card functionality with proper accessibility
	 * @param {HTMLElement} block
	 * @param {HTMLElement} anchor
	 */
	setupIconCard( block, anchor ) {

		const href = anchor.getAttribute( 'href' );
		if ( !href || href.trim() === '' ) {

			return;

		}

		const target = anchor.getAttribute( 'target' );

		// Get link text for aria-label
		const linkText = anchor.textContent.trim();
		const titleEl = block.querySelector( '.b-icon-card__title' );
		const cardTitle = titleEl ? titleEl.textContent.trim() : linkText;

		// Make all links inside non-focusable
		const allLinks = block.querySelectorAll( 'a' );
		allLinks.forEach( ( link ) => {

			link.setAttribute( 'tabindex', '-1' );
			link.setAttribute( 'aria-hidden', 'true' );

		} );

		// Make card focusable and accessible
		block.setAttribute( 'tabindex', '0' );
		block.setAttribute( 'role', 'link' );
		block.setAttribute( 'aria-label', cardTitle );

		// Handle click
		block.addEventListener( 'click', ( e ) => {

			// Prevent if clicking on a link directly (shouldn't happen but safety)
			if ( e.target.tagName === 'A' ) {

				return;

			}

			this.navigateToUrl( href, target );

		} );

		// Handle keyboard (Enter and Space)
		block.addEventListener( 'keydown', ( e ) => {

			if ( e.key === 'Enter' || e.key === ' ' ) {

				e.preventDefault();
				this.navigateToUrl( href, target );

			}

		} );

		block.classList.add( 'has-stretched-link' );

	}

	/**
	 * Navigate to URL
	 * @param {string} href
	 * @param {string} target
	 */
	navigateToUrl( href, target ) {

		if ( target === '_blank' ) {

			window.open( href, '_blank' );

		} else {

			window.location.href = href;

		}

	}

}
